import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {StatisticsApiService} from '@core/services/api/statistics-api.service';
import {AlertService} from '@core/services/alert.service';
import {CpfCnpjPipe} from '@shared/pipes/app-cpfcnpj.pipe';
import {AppPhoneComponent} from "@shared/components/commons/app-phone/app-phone.component";
import {copyToClipboard} from "@shared/commons/keyboard.commons";

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [CommonModule, CpfCnpjPipe, AppPhoneComponent],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
    private statisticsApi = inject(StatisticsApiService);
    private alertService = inject(AlertService);
    private router = inject(Router);

    // KPIs
    protected totalCompanies = 0;
    protected totalDebt = 0;
    protected totalUsers = 0;
    protected currentSelicRate = 0;
    protected selicReferenceDate = '';

    // Listas
    protected latestCompaniesWithDebt: any[] = [];
    protected loading = true;

    ngOnInit(): void {
        this.loadDashboardData();
    }

    private loadDashboardData(): void {
        this.loading = true;

        this.statisticsApi.getDashboardStatistics()
            .subscribe({
                next: (response) => {
                    const data = response.data;

                    this.totalCompanies = data.totalCompanies || 0;
                    this.totalDebt = data.totalEstimatedDebt || 0;
                    this.totalUsers = data.totalUsers || 0;
                    this.currentSelicRate = data.latestSelicRate || 0;
                    this.selicReferenceDate = data.latestSelicDate || '';

                    this.latestCompaniesWithDebt = data.latestCompaniesWithDebt || [];

                    this.loading = false;
                },
                error: () => {
                    this.alertService.operationFailure();
                    this.loading = false;
                }
            });
    }

    protected viewCompanyDetails(documentNumber: string): void {
        this.router.navigate(['/companies'], {queryParams: {q: documentNumber}});
    }

    protected viewAllCompanies(): void {
        this.router.navigate(['/companies']);
    }

    protected viewSelic(): void {
        this.router.navigate(['/selic']);
    }

    protected async copy(value: any) {
        await copyToClipboard(value);
        this.alertService.success('messages.success.label', 'messages.success.copy_to_clipboard');
    }

    protected readonly copyToClipboard = copyToClipboard;
}


